import { useLocation, Link } from "react-router-dom";
import { useState } from "react";
import { useTranslation, Trans } from "react-i18next";
import ContactUsDialog from "components/ModalDialogs/ContactUsDialog";
import config from "config/config";
import { getImage } from "js/utilities";

export default function FooterEVL({ portal }) {
  const location = useLocation();
  const configurationObject = {
    isCookiesPromptEnabled: false,
  };

  const [contactUsDialogState, setContactUsDialogState] = useState(false);

  const { t } = useTranslation();
  return (
    <>
      <footer>
        <div className="container py-6 lg:py-8">
          <div className="flex w-full flex-grow justify-between items-start">
            <div className="flex flex-wrap flex-row items-start text-sm  md:items-center md:text-base">
              {location.pathname !== "/payee" && (
                <Link to="/help" className="inline-block mb-4 mr-8">
                  {t("Footer-link-1")}
                </Link>
              )}

              <Link
                to="#"
                className="ui-link inline-block mb-4 mr-8"
                onClick={() => setContactUsDialogState(true)}
              >
                {t("Footer-link-2")}
              </Link>
              <a
                href={t("Footer-visit-us-url")}
                target="_blank"
                className="inline-flex items-center basis-full mb-4 sm:basis-auto"
                rel="noreferrer"
              >
                <svg
                  className="ui-icon w-6 h-6 mr-3"
                  focusable="false"
                  aria-hidden="true"
                  role="presentation"
                >
                  <use href="#ui-icon-external-link"></use>
                </svg>
                {t("Footer-link-3")}
              </a>
            </div>
            <div className="flex items-start">
              <Link
                to={`${
                  portal === "agent"
                    ? "/dashboard"
                    : location.pathname === "/payee"
                    ? "#"
                    : "/policies"
                }`}
                title="Return to dashboard"
              >
                <div id="everlakeLogoFooter" className="ui-logo">
                  <img
                    src={getImage("logo_white.png")}
                    className="ui-logo-footer-mobile"
                    alt="Everlake Logo"
                  />
                </div>
                <div id="lumicoLogoFooter" className="ui-logo">
                  <img
                    src={getImage("image5.png")}
                    className="ui-logo-footer-mobile"
                    alt="Lumico Logo"
                  />
                </div>
              </Link>
            </div>
          </div>
          <div className="flex flex-col">
            <div className="flex flex-col-reverse flex-wrap md:flex-row text-xs">
              <div
                className="mb-2 mr-5 basis-full sm:basis-auto"
                role="presentation"
              >
                <Trans
                  defaults={t("Footer-copyright")}
                  values={{ year: new Date().getFullYear() }}
                />
              </div>
              <div>
                <Link
                  className="inline-flex items-center basis-full mb-1 mr-3 sm:basis-auto"
                  to="/terms-of-use"
                >
                  {/* <svg
                    className="ui-icon mr-1 w-3 h-3 inline-block"
                    focusable="false"
                    aria-hidden="true"
                    role="presentation"
                  >
                    <use href="#ui-icon-external-link"></use>
                  </svg> */}
                  {t("Footer-link-4")}
                </Link>
                <Link
                  className="inline-flex items-center basis-full mb-1 mr-3 sm:basis-auto"
                  to="/privacy-policy"
                >
                  {/* <svg
                    className="ui-icon mr-1 w-3 h-3 inline-block"
                    focusable="false"
                    aria-hidden="true"
                    role="presentation"
                  >
                    <use href="#ui-icon-external-link"></use>
                  </svg> */}
                  {t("Footer-link-5")}
                </Link>
                {/* <a
                  className="inline-flex items-center basis-full mb-1 mr-3 sm:basis-auto"
                  target="_blank"
                  href="https://www.everlakelife.com/accessibility-statement/"
                >
                  <svg
                    className="ui-icon mr-1 w-3 h-3 inline-block"
                    focusable="false"
                    aria-hidden="true"
                    role="presentation"
                  >
                    <use href="#ui-icon-external-link"></use>
                  </svg>
                  Accessibility Statement
                </a> */}
              </div>
            </div>
            {configurationObject.isCookiesPromptEnabled ? (
              localStorage.getItem("isCookiesAccepted") &&
              localStorage.getItem("isCookiesAccepted") === "true" ? (
                ""
              ) : (
                <>
                  <hr className="mt-2 mb-4" />
                  <div className="flex flex-wrap flex-grow justify-center text-xs">
                    <span className="mb-4 mr-5">{t("Cookies-title")}</span>
                    <div className="block md:inline">
                      <Link to="/policies" className="mb-4 mr-5">
                        {t("Cookies-button-1")}
                      </Link>
                      <Link
                        to="/policies"
                        className="mb-4 mr-5"
                        onClick={() =>
                          localStorage.setItem("isCookiesAccepted", "true")
                        }
                      >
                        {t("Cookies-button-2")}
                      </Link>
                    </div>
                  </div>
                </>
              )
            ) : (
              <></>
            )}
          </div>
        </div>
      </footer>

      <ContactUsDialog
        dialogState={contactUsDialogState}
        setDialogState={setContactUsDialogState}
      />
    </>
  );
}
